import { render, staticRenderFns } from "./DisputesDialog.vue?vue&type=template&id=6bb387a1&scoped=true"
import script from "./DisputesDialog.vue?vue&type=script&lang=js"
export * from "./DisputesDialog.vue?vue&type=script&lang=js"
import style0 from "./DisputesDialog.vue?vue&type=style&index=0&id=6bb387a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb387a1",
  null
  
)

export default component.exports